import script from "./StoreDetailsScript.vue?vue&type=script&lang=js"
export * from "./StoreDetailsScript.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__